import React from "react";
import { Stack, Typography, styled, Button } from "@mui/material";
export interface RememberMeFormInterface {
  handleAction: (type: string, data?: any) => void;
}
const ButtonStack = styled(Stack)(({ theme }: any) => ({
  "& .shadow-button": {
    color: theme.palette.common.black,
    background: theme.palette.common.white,
    borderRadius: "15px",
    boxShadow: `0px 0.866667px 3.46667px rgba(0, 0, 0, 0.25)`,
    padding: "5px 10px",
    width: "100%",
  },
}));
const RememberMeForm = ({ handleAction }: RememberMeFormInterface) => {
  return (
    <Stack
      width="100%"
      height="100%"
      alignItems="center"
      justifyContent="space-between"
      pb={2}
    >
      <Stack
        paddingX={2}
        spacing={1.5}
        textAlign="center"
        alignItems="center"
        justifyContent="center"
      >
        <Typography variant="h1" fontWeight={700} textAlign="center">
          Remember me on this browser
        </Typography>
        <Typography variant="h4" fontWeight={400} textAlign="center">
          You won't need to enter your sign in information the next time you
          visit Eventview360.
        </Typography>
      </Stack>
      <ButtonStack
        spacing={3}
        width="60%"
        minWidth="200px"
        alignItems="center"
        justifyContent="center"
        alignSelf="center"
      >
        <Button
          color="primary"
          variant="contained"
          fullWidth
          onClick={() => handleAction("remember-and-signout")}
        >
          Remember and sign out
        </Button>
        <Button
          className="shadow-button"
          variant="text"
          color="secondary"
          onClick={() => handleAction("signout")}
        >
          Signout
        </Button>
      </ButtonStack>
    </Stack>
  );
};
export default RememberMeForm;
